import { Link } from "react-router-dom";
import type { Statement } from "@/types/content";

const badgeStyles: Record<string, string> = {
  statement: "bg-secondary-100 text-secondary-900",
  refute: "bg-accent-100 text-accent-900",
  response: "bg-primary-50 text-primary-700",
  notice: "bg-background-200 text-foreground-700",
};

export default function StatementCard({ statement }: { statement: Statement }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/statements/${statement.id}`} className="flex h-full flex-col cursor-pointer">
        <div className="h-44 w-full overflow-hidden bg-background-200">
          <img
            src={statement.cover}
            alt={statement.title}
            title={`${statement.title} - 黑料官方公告配图`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </div>
        <div className="flex flex-1 flex-col p-5">
          <div className="flex flex-wrap items-center gap-3 text-xs">
            <span className={`rounded-full px-2.5 py-1 font-medium ${badgeStyles[statement.categoryId] ?? badgeStyles.notice}`}>
              {statement.categoryName}
            </span>
            <time dateTime={statement.date} className="text-foreground-500">
              {statement.date}
            </time>
          </div>
          <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
            {statement.title}
          </h3>
          <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
            {statement.summary}
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {statement.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="rounded-md bg-background-100 px-2 py-1 text-xs text-foreground-600">
                {tag}
              </span>
            ))}
          </div>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
            查看全文
            <span className="flex h-4 w-4 items-center justify-center"><i className="ri-arrow-right-line" /></span>
          </span>
        </div>
      </Link>
    </article>
  );
}